// extracted by mini-css-extract-plugin
export default {"autoinput":"AutoCompleteInput_autoinput__w0spP"};